var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.toast.show)?_c('div',{staticClass:"toast-wrapper",style:(_vm.position(_vm.toast.options.position))},[_c('div',{staticClass:"toast flex-row items-center",class:_vm.toast.type},[_c('div',{staticClass:"flex-fill",domProps:{"innerHTML":_vm._s(_vm.html)}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }